import request from "@/router/axios";
// 检车报告列表
export const getReport = (data) => {
  return request({
    url: "/check/train/detailList/vehicleInspectionReport",
    method: "post",
    data,
  });
};

export const editReport = (ReportEditDTO) => {
  return request({
    url: "/api/trainlistline/editReport",
    method: "post",
    data: ReportEditDTO,
  });
};

export const confirmReport = (trainId) => {
  return request({
    url: `/check/train/detailList/saveEndedListen?trainId=${trainId}`,
    method: "post",
  });
};

export const exportExcel = (data) => {
  return request({
    url: "/check/train/detailList/vehicleInspectionReportExport",
    method: "post",
    data,
    responseType: "blob",
  });
};


export const updateOrderToLocation = (data) => {
  return request({
    url: "/check/train/detailList/updateOrderToLocation",
    method: "post",
    data: data,
  });
};
